import React from 'react'

const Info = () => {
  return (
    <>
      <section
        className="u-py-40 startup-statistics"
        style={{ backgroundColor: "#ECF5FE" }}
      >
        <div className="container">
          <div className="row text-center">
            <div className="col-lg-3 col-md-6 u-my-20 text-blue">
              <h4 className="u-fs-50 color-heading">50,000 sq.ft</h4>
              <p className="u-fs-20 mb-0">
                <span className="icon icon-Podium u-fs-30 mr-2"></span> Total Work
                Space
              </p>
            </div>
            <div className="col-lg-3 col-md-6 u-my-20 text-blue">
              <h4 className="u-fs-50 color-heading">600+</h4>
              <p className="u-fs-20 mb-0">
                <span className="icon icon-DesktopMonitor u-fs-30 mr-2"></span>{" "}
                Seating Capacity
              </p>
            </div>
            <div className="col-lg-3 col-md-6 u-my-20 text-blue">
              <h4 className="u-fs-50 color-heading">100+</h4>
              <p className="u-fs-20 mb-0">
                <span className="icon icon-Starship u-fs-30 mr-2"></span> Startups &
                Companies
              </p>
            </div>
            <div className="col-lg-3 col-md-6 u-my-20 text-blue">
              <h4 className="u-fs-50 color-heading">10+</h4>
              <p className="u-fs-20 mb-0">
                <span className="icon icon-Pointer u-fs-30 mr-2"></span> Locations
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Info